import  publication from './publication';
import  common from './common';
import  security from './security';

export default {
    ...common,
    ...security,
    ...publication,
};



// WEBPACK FOOTER //
// ./src/api/index.js